import React from "react";
import ProductModalMultiSize from "./productModalMultiSize";
import ProductModalSizeList from "./productModalSizeList";
import ProductSizeFormatMessages from "../../productSizeGeneralComponents/productSizeFormatMessages";

const ProductModalSize = ({
  productSizes,
  isProductMultisize,
  activeSizeType,
  mobileProductHighlights,
  showProductSizeChart
}) => {
  return (
    <>
      {isProductMultisize && activeSizeType ? (
        <div className="multiSizeWrapper">
          <ProductModalMultiSize />
          <ProductSizeFormatMessages
            productHighlights={mobileProductHighlights}
            containerClassName="additional_size_info"
            clickHandlers={[showProductSizeChart]}
            withNoBorder
          />
        </div>
      ) : (
        <div className="one_size_item">
          {productSizes?.[0] && (
            <ProductModalSizeList
              productSizes={productSizes[0].variants}
              isActive
            />
          )}
          <ProductSizeFormatMessages
            productHighlights={mobileProductHighlights}
            containerClassName="additional_size_info"
            clickHandlers={[showProductSizeChart]}
            withNoBorder
          />
        </div>
      )}
    </>
  );
};

export default ProductModalSize;
